module.exports = __webpack_public_path__ + "static/media/mainImg.74b70265.png";